import { DataHeader, DataSource, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommUnit extends Layout {
    dataheaderMobileCommUnit: DataHeader;
    labelDetail: Label;
    panelMobileCommUnit: Panel;
    sourceMCUnitAll: DataSource;
    sourceMCUnitDetail: DataSource;
    tableMCUnitDetail: Table;
    textboxAddress: Textbox;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxUnitType: Textbox;
    textboxVendor: Textbox;
    textboxReeferId: Textbox;
}
